export default function format(subAccountsNames: string[], billerName: string): string {
  const formattedSubAccounts = subAccountsNames.length > 0 ? `(${subAccountsNames.join(', ')})` : '';
  return `${billerName} ${formattedSubAccounts}`;
}
